const parseLink = (message: string) => {
	const linkRegex = /((https?|ftp):\/\/[^\s/$.?#].[^\s]*)/gi
	return message.replace(linkRegex, (match) => {
		return `<a href='${match}' target="_blank">${match}</a>`;
	});
}

const parseNewline = (message: string) => {
	return message.replace(/\n/g, '<br>')
}

export const parseMessage = (message: string) => {
	const parsedMessage = parseNewline(message)
	return parseLink(parsedMessage)
}
